import React, { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Skeleton,
  Row,
  Col,
  Select,
  Checkbox,
  DatePicker,
} from "antd";
import moment from "moment";

import { GlobalOutlined } from "@ant-design/icons";

import util from "../../utils/functions/custom";
import {AddressControl, ContactField, openNotification, progressIndicatorEnum} from "@seims/shared";
import { Messages, Notify } from "../../services/custom/Messages";
import lookupAPI from "../../services/candidateLookupService";
import api from "../../services/nysService";
import { getProfile } from "../../security/AppSecurity";
import { recordError } from "../../utils/logService";

const PersonalInformationView = ({ onProgressUpdate, data, readOnly }) => {
  const [titles, setTitles] = useState([]);
  const [races, setRaces] = useState([]);
  const [provinces, setProvince] = useState([]);
  const [genders, setGenders] = useState([]);
  const [address, setAddress] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAddressInfo, setshowAddressInfo] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [userData, setUserData] = useState(getProfile());
  const [contactValue, setContactValue] = useState("");
  const [altContactValue, setAltContactValue] = useState("");
  const [active, setActive] = useState(true);
  const [demographyData, setDemographyData] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [activities, setActivities] = useState([]);

  const formItemLayout = {
    layout: "vertical",
  };

  const { Option } = Select;
  const { Meta } = Card;
  const [form] = Form.useForm();
  const formName = "PersonalInformationForm";

  useEffect(() => {
    // getTitles();
    // getRaces();
    // getGenders();

  }, []);

  useEffect(() => {
    getDemographics();
  }, [titles, genders, races, data]);

  const getDemographics = async () => {
    const { firstName, lastName } = userData;
    try {

      setActive(false);

      form.setFieldsValue({
        name: firstName,
        surname: lastName
      })

      if (!util.isEmpty(data)) {
        setActive(true);

        form.setFieldsValue({
          id: data.id,
          name: data.name,
          surname: data.surname,
          title: data.title,
          idNumber: data.idNumber,
          email:data.email,
          gender: data.gender,
          homeProvince: data.homeProvince,
          genderOther: data.gender_other,
          preferredProvince: data.preferredProvince,
          preNYSActivity: data.preNYSActivity,
          race: data.race,
          dob: moment(data.dob),
          address: data.address,
          disability: data.disability,
          alternativePersonFullName: data.alternativePersonFullName,
        });

        setDemographyData(data);
        setAltContactValue(data.alternativeCellNumber);
        setContactValue(data.cellNumber);
        setAddress(data.address);
        setshowAddressInfo(true);
        setActive(false);
        setIsDisabled(data.disability);
      }
    } catch (error) { }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleModalSubmit = (values) => {
    let _address = { ...values, country: values.country.value };

    _address = {
      ...values,
      country: values.country.value,
      province: values.province.value,
    };

    setAddress(_address);
    setShowModal(false);
    setshowAddressInfo(true);
  };

  const handleContactChange = (value) => {
    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ cellNumber: undefined });
      return;
    }
    form.setFieldsValue({ cellNumber: value });
  };

  const handleAltContactChange = (value) => {
    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ alternativeCellNumber: undefined });
      return;
    }
    form.setFieldsValue({ alternativeCellNumber: value });
  };

  const onIdChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ idno: util.toNumeric(value) });
  };

  const onChangeCheck = (e) => {
    const { checked } = e.target;
    setIsDisabled(checked);
  };

  const onSubmit = async (values) => {
    try {
      const user = getProfile();

      const {
        title,
        name,
        surname,
        idNumber,
        disability,
        gender,
        genderOther,
        homeProvince,
        preNYSActivity,
        preferredProvince,
        race,
        dob,
        cellNumber,
        alternativePersonFullName,
        alternativeCellNumber,
      } = values;

      const demographics = {
        id: demographyData?.id > 0 ? demographyData.id : "-1",
        title: title,
        name: name,
        surname: surname,
        idNumber: idNumber,
        disability: isDisabled,
        gender: gender,
        genderOther: genderOther,
        homeProvince: homeProvince,
        preNYSActivity: preNYSActivity,
        preferredProvince: preferredProvince,
        race: race,
        dob: new Date(dob),
        email: user.emailAddress,
        userId: user.userId,
        cellNumber: cellNumber,
        alternativePersonFullName: alternativePersonFullName,
        alternativeCellNumber: alternativeCellNumber,
        address: address,
      };

      onProgressUpdate(progressIndicatorEnum.IN_PROGRESS);
      const request = await api.addDemographics(demographics);
      var msg;

      if (request.status == 200 || request.status == 201) {

        onProgressUpdate(progressIndicatorEnum.COMPLETED);
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Personal info detail(s)");
        openNotification("Save Personal Info", msg, Notify.SUCCESS);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Personal info detail(s)");
      openNotification("Save Personal Info", msg, Notify.ERROR);

    } catch (error) {

      onProgressUpdate(progressIndicatorEnum.NOT_STARTED);
      // console.log("PERSONAL INFO FAILED TO SAVE", error);
      recordError(error);
      openNotification("Save Personal Info", "SYSTEM FAILED TO SAVE", Notify.ERROR);
    }
  };

  const disabilityLabel = `${isDisabled ? "Yes!" : "No!"}`;

  return (
    <>
      {/* <PageHeader
        title="Demographics Information"
        subTitle="Please fill in your demographic information"
      ></PageHeader> */}
      <h1 className="center-align">Personal Information</h1>
      <p className="sub-title center-align">
        Please fill in your personal information
      </p>
      <br />
      {active ? (
        <Skeleton active={active} />
      ) : (
        <>
          <Form
            {...formItemLayout}
            name={formName}
            form={form}
            onFinish={onSubmit}
            disabled
          >
            <Row>
              <Col xs={24} md={10}>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[
                    { required: true, message: "Please enter firstname" },
                  ]}
                >
                  <Input name="title" onBlur={onNameBlur} disabled />
                </Form.Item>
              </Col>
              <Col md={2}></Col>
              <Col xs={24} md={10}>
                <Form.Item
                  name="name"
                  label="Firstname"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input name="firstname" onBlur={onNameBlur} disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} md={10}>
                <Form.Item
                  name="surname"
                  label="Lastname"
                  rules={[
                    { required: true, message: "Please enter your lastname" },
                  ]}
                >
                  <Input name="surname" onBlur={onNameBlur} disabled />
                </Form.Item>
              </Col>
              <Col span={2}></Col>
              <Col xs={24} md={10}>
                <Form.Item
                  name="idNumber"
                  label="ID no"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your Identity number",
                    },
                  ]}
                >
                  <Input
                    name="idNumber"
                    onChange={onIdChange}
                    minLength={13}
                    maxLength={13}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} md={10}>
                <Form.Item
                  name="disability"
                  label="Have a disability?"
                  rules={[{ required: true }]}
                >
                  <Checkbox
                    name="disability"
                    onChange={onChangeCheck}
                    checked={isDisabled}
                    disabled
                  >
                    {disabilityLabel}
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={2}></Col>
              <Col xs={24} md={10}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[
                    { required: true, message: "Please select your gender" },
                  ]}
                >
                  <Input name="gender" onBlur={onNameBlur} disabled />
                </Form.Item>
                {showOther && (
                  <Form.Item
                    name="genderOther"
                    label="Other"
                    rules={[
                      {
                        required: true,
                        message: "Please enter other gender",
                      },
                    ]}
                  >
                    <Input disabled />
                  </Form.Item>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={24} md={10}>
                <Form.Item
                  name="race"
                  label="Race"
                  rules={[
                    { required: true, message: "Please select your race" },
                  ]}
                >
                  <Input name="race" onBlur={onNameBlur} disabled />
                </Form.Item>
              </Col>
              <Col span={2}></Col>
              <Col xs={24} md={10}>
                <Form.Item
                  name="dob"
                  label="Date of birth"
                  rules={[
                    {
                      required: true,
                      message: "Please select your date of birth",
                    },
                  ]}
                >
                  <DatePicker disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} md={10}>
                <Form.Item
                  name="cellNumber"
                  label="Cellphone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your cellphone number",
                    },
                  ]}
                >
                  <ContactField 
                    contactValue={contactValue}
                    onContactChange={handleContactChange}
                    disabled
                  />
                </Form.Item>
                </Col>
                <Col span={2}></Col>
                <Col xs={12} md={10}>
                  <Form.Item
                    name="homeProvince"
                    label="Home province"
                    rules={[
                      {
                        required: true,
                        message: "Please select your home province",
                      },
                    ]}
                  >
                    <Input name="homeProvince" onBlur={onNameBlur} disabled />
                  </Form.Item>
                </Col>
                <Col span={2}></Col>
                <Col xs={24} md={10}>
                  <Form.Item
                    name="address"
                    label="Address"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your address",
                      },
                    ]}
                  >
                    {!showAddressInfo && (
                      <Button onClick={() => setShowModal(true)}>
                        Add Address
                      </Button>
                    )}
                    <div
                      style={{ width: 300, display: "flex", marginBottom: 20 }}
                    >
                      {showAddressInfo && (
                        <Card
                          style={{
                            width: "100%",
                            justifyContent: "center",
                            marginBottom: 10,
                            backgroundColor: "rgb(250 250 250)",
                            borderBlockStyle: "solid",
                            borderColor: "#CCC",
                          }}
                        >
                          <Meta
                            avatar={<Avatar icon={<GlobalOutlined />} />}
                            title="Local Address"
                            description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}`}
                          />
                        </Card>
                      )}
                    </div>
                  </Form.Item>
                </Col>
                <Col span={2}></Col>
                <Col span={10}>
                  <Form.Item
                    name="email"
                    label="Email Address"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your cellphone",
                      },
                    ]}
                  >
                    <Input name="email" />
                  </Form.Item>
                </Col>
              </Row>
            <Card
              title="Preferred Placement and Employment Details"
              bordered={true}
              headStyle={{ border: 0, textAlign: "center" }}
            >
              <Row>
                <Col xs={12} md={10}>
                  <Form.Item
                    name="preferredProvince"
                    label="Preferred placement province"
                    rules={[
                      {
                        required: true,
                        message: "Please select your preferred placement province",
                      },
                    ]}
                  >
                    <Select disabled>
                      {provinces.map((province) => (
                        <Option key={province.key}>{province.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={2}></Col>
                <Col xs={12} md={10}>
                  <Form.Item
                    name="preNYSActivity"
                    label="Current employment status"
                    rules={[
                      {
                        required: true,
                        message: "Please select your current employment status",
                      },
                    ]}
                  >
                    <Select disabled> 
                      {activities.map((activity) => (
                        <Option key={activity.key} value={activity.value}>
                          {activity.value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card
              title="Alternative Contact Person"
              bordered={true}
              headStyle={{ border: 0, textAlign: "center" }}
            >
              <Row>
                <Col xs={24} md={10}>
                  <Form.Item
                    name="alternativePersonFullName"
                    label="Full name"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Input
                      name="alternativePersonFullName"
                      onBlur={onNameBlur}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={2}></Col>
                <Col xs={24} md={10}>
                  <Form.Item
                    name="alternativeCellNumber"
                    label="Cellphone No"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <ContactField
                      contactValue={altContactValue}
                      onContactChange={handleAltContactChange}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <br />
            <Row justify="end">
              <Col xs={24}>
                {false && (
                  <Button
                    key="2"
                    htmlType="submit"
                    form={formName}
                    type="primary"
                    className="right-align-button"
                  >
                    Save Personal Information
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
          <AddressControl
            key="1"
            onCancel={handleCancel}
            visible={showModal}
            title="Edit Address"
            isLocal={true}
            onModalSubmit={handleModalSubmit}
            address={address}
          />
        </>
      )}
    </>
  );
};

export default PersonalInformationView;
